module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.37684a0a.otf";